import React from 'react';
import './secondarycta.css'
import { Link } from 'react-router-dom';

const SecCta = (props) => {
  if (props.to) {
    return (
      <Link
        to={props.to}
        className="button-container2"
        onClick={props.onClick}
      >
        <h2 className="text-button2">{props.title}</h2>
      </Link>
    );
  }



    return ( 
        <button className='button-container2' onClick={props.onClick}>
            <h2 className='text-button2'>{props.title}</h2>
        </button>
     );
}
 
export default SecCta;